class APIS {
	apis() {
		return {
			getPbxAccountConfig: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/account/me'
			},
			pbxCallEvents: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/calls/events'
			},
			pbxCallRecording: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/calls/recording'
			},
			pbxCallsList: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/calls/list'
			},
			pbxCallsStats: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/calls/stats'
			},
			pbxAgentLogsGet: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/agent/logs/list'
			},
			pbxCallsDetails: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/calls/detail'
			},
			pbxAgentStateChange: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/agent/state'
			},
			pbxAgentStateGet: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/agent/state/current'
			},
			pbxAgentPresenceList: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/agent/presence/list'
			},
			pbxCustomerCreate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/customers/create'
			},
			pbxCustomerUpdate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/customers/update'
			},
			pbxCustomerDetail: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/customers/detail'
			},
			pbxCustomerList: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/customers/list'
			},
			pbxCustomerDelete: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/customers/delete'
			},
			pbxCustomerAttributesGet: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/customers/attributes'
			},
			pbxCustomerGet: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/fetch/contacts'
			},
			pbxAccountCreate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/account/create'
			},
			pbxAccountList: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/account/list'
			},
			pbxAccountUpdate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/account/update'
			},
			pbxAccountDelete: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/account/delete'
			},
			pbxTicketCreate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/tickets/create'
			},
			pbxTicketUpdate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/tickets/update'
			},
			pbxTicketDetail: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/tickets/detail'
			},
			pbxTicketList: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/tickets/list'
			},
			pbxTicketSearch: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/tickets/search'
			},
			pbxTicketCallsLink: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/tickets/calls/link'
			},
			pbxTicketCallsUnlink: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/tickets/calls/unlink'
			},
			pbxTicketDelete: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/tickets/delete'
			},
			pbxTicketCounts: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/tickets/counts'
			},
			pbxTicketStatusCreate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/ticket-statuses/create'
			},
			pbxTicketStatusUpdate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/ticket-statuses/update'
			},
			pbxTicketStatusList: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/ticket-statuses/list'
			},
			pbxTicketStatusDelete: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/pbx/ticket-statuses/delete'
			},
		};
	}
}

export default new APIS();